import { render, staticRenderFns } from "./OperaProjectRoleSorceWindow.vue?vue&type=template&id=d5bbab9c&scoped=true&"
import script from "./OperaProjectRoleSorceWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectRoleSorceWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectRoleSorceWindow.vue?vue&type=style&index=0&id=d5bbab9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bbab9c",
  null
  
)

export default component.exports